import React from 'react';
import type { ButtonProps, LinkProps } from '@chakra-ui/react';
import { Flex, Box, Button } from '@chakra-ui/react';
import { FaLongArrowAltLeft, FaLongArrowAltRight } from 'react-icons/fa';
import ButtonLink from '../ButtonLink';

type PagerButtonProps = SharedProperties<ButtonProps, LinkProps>;
const pagerButtonProps: PagerButtonProps = {
    textDecoration: 'none',
    textTransform: 'lowercase',
    whiteSpace: 'normal',
    height: 'auto',
    px: 2,
    py: 2,
    bg: 'blackAlpha.800',
};

const PageButton = ({
    path,
    enabled,
    ...props
}: {
    path: string;
    enabled: boolean;
} & PagerButtonProps) =>
    enabled ? (
        <ButtonLink to={path} {...pagerButtonProps} {...props} />
    ) : (
        <Button {...pagerButtonProps} isDisabled {...props} />
    );

const Pagination = ({
    prevPagePath,
    nextPagePath,
    hasPrevPage,
    hasNextPage,
}: {
    prevPagePath: string;
    nextPagePath: string;
    hasPrevPage: boolean;
    hasNextPage: boolean;
}) => (
    <Flex width="100%" px={[8, 8, 12]} justifyContent="center">
        <PageButton path={prevPagePath} enabled={hasPrevPage} px={3} mx={4}>
            <Box as={FaLongArrowAltLeft} pr={3} w="100%" /> Previous
        </PageButton>
        <PageButton path={nextPagePath} enabled={hasNextPage} px={3} mx={4}>
            Next <Box as={FaLongArrowAltRight} pl={3} w="100%" />
        </PageButton>
    </Flex>
);

export default Pagination;
